import React from "react";
import { observer } from "mobx-react-lite";

import {
  ActionsSection,
  ButtonsSection
} from "../../../components/data-components/sections/DataSections";
import EditButton from "../../../components/buttons/edit-button/EditButton";
import { DeleteAccountButton } from "../components/buttons/DeleteAccountButton";
import { ChangePassword } from "../../../components/data-components/ChangePassword";

export default observer((props: {onEdit: () => void}) => {
  return (
    <ActionsSection isSticky={false}>
      <ButtonsSection>
        <EditButton onClick={() => props.onEdit()} />
        <DeleteAccountButton />
      </ButtonsSection>
      <ButtonsSection>
        <ChangePassword />
      </ButtonsSection>
    </ActionsSection>
  );
});
